import { render, staticRenderFns } from "./DataExtractionPanel.vue?vue&type=template&id=abe05e62&scoped=true&"
import script from "./DataExtractionPanel.vue?vue&type=script&lang=js&"
export * from "./DataExtractionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DataExtractionPanel.vue?vue&type=style&index=0&id=abe05e62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abe05e62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
